import { NgModule } from "@angular/core";
import { MainHeaderComponent } from "./features/app/main-header/main-header.component";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { MainFooterComponent } from "./features/app/main-footer/main-footer.component";
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from "./shared/loader/loader.component";
import { UnroadworthyWarningComponent } from "./shared/unroadworthy-warning/unroadworthy-warning.component";
import { SafetyDefectsWarningComponent } from "./shared/safety-defects-warning/safety-defects-warning.component";
import { AuthFormComponent } from "./features/auth/auth-form/auth-form.component";
import { FormsModule } from "@angular/forms";
import { ErrorPanelComponent } from "./shared/error-panel/error-panel.component";
import { FormatNumberPipe } from "../pipes/format-number/format-number-pipe";
import { MainMenuComponent } from "./features/app/main-menu/main-menu.component";
import { MobileMenuComponent } from "./features/app/mobile-menu/mobile-menu.component";
import { VehicleDetailCardComponent } from "./shared/vehicle-detail-card/vehicle-detail-card.component";
import { VoVehicleDetailCardComponent } from "./features/vo-vehicle-detail-card/vo-vehicle-detail-card.component";
import { CsatDetailsCardComponent } from "./features/dashboard/csat-details-card/csat-details-card.component";
import { OpenAppointmentsCardComponent } from "./features/unroadworthy-defects/open-appointments-card/open-appointments-card.component";
import { DetailedVehicleInfoCardComponent } from "./features/vehicle-details/detailed-vehicle-info-card/detailed-vehicle-info-card.component";
import { UnrectifiedVehicleDetailsComponent } from "./features/vehicle-details/unrectified-vehicle-details/unrectified-vehicle-details.component";
import { UnroadworthyVehicleBannerComponent } from "./shared/unroadworthy-vehicle-banner/unroadworthy-vehicle-banner.component";
import { VehicleRegistrationHeaderComponent } from "./shared/vehicle-registration-header/vehicle-registration-header.component";
import { ViewMediaComponent } from "./shared/view-media/view-media.component";
import { PreferredGarageCardComponent } from "./features/vehicle-details/preferred-garage-card/preferred-garage-card.component";
import { FormatDatePipe } from "../pipes/format-date/format-date-pipe";
import { CustomSelectComponent } from "./shared/custom-select/custom-select.component";
import { ContactDetailsCardComponent } from "./features/contact/contact-details-card/contact-details-card.component";
import { VehicleReallocationRequestDetailsComponent } from "./features/vehicle-reallocation/vehicle-reallocation-request-details/vehicle-reallocation-request-details.component";
import { OpenDefectsHeaderComponent } from "./features/open-defects/open-defects-header/open-defects-header.component";
import { OpenDefectsWarningComponent } from "./shared/open-defects-warning/open-defects-warning.component";
import { AddNewPreUseInspectionHeaderComponent } from "./features/add-new-pre-use-inspection/add-new-pre-use-inspection-header/add-new-pre-use-inspection-header.component";
import { PUITemplatesComponent } from "./features/add-new-pre-use-inspection/pui-templates/pui-templates.component";
import { PreUseInspectionListComponent } from "./features/pre-use-inspection/pre-use-inspection-list/pre-use-inspection-list.component";
import { DamageClaimsCardComponent } from "./features/accident-damage/damage-claims-card/damage-claims-card.component";
import { SupportTopicsCardComponent } from "./features/request-service/support-topics-card/support-topics-card.component";
import { ServiceProviderComponent } from "./features/request-service/service-provider/service-provider.component";
import { VendorServiceListComponent } from "./features/request-service/vendor-service-list/vendor-service-list.component";
import { RectifyDefectStepperComponent } from "./shared/rectify-defect-stepper/rectify-defect-stepper.component";
import { ReviewDefectsComponent } from "./shared/review-defects/review-defects.component";
import { VendorListComponent } from "./features/garage-service/vendor-list/vendor-list.component";
import { VehicleOrderInformationComponent } from "./features/vehicle-order-information/vehicle-order-information.component";
import { VoStandardVehicleInformationComponent } from "./features/vo-standard-vehicle-information/vo-standard-vehicle-information.component";
import { NewHeaderComponent } from "./shared/new-header/new-header.component";
import { DefectDigitalSignaturepadComponent } from "./shared/defect-digital-signaturepad/defect-digital-signaturepad.component";
import { AuthMainComponent } from "./features/auth/auth-main/auth-main.component";
import { CompletedQuoteStepperComponent } from "./features/completed-quote-stepper/completed-quote-stepper/completed-quote-stepper.component";
import { MyVehicleOrderComponent } from "./features/my-vehicle-order/my-vehicle-order.component";
import { SuccessCardComponent } from "./shared/success-card/success-card/success-card.component";
import { VehicleSpecGridComponent } from "./features/vehicle-config/vehicle-spec-grid/vehicle-spec-grid.component";
import { VehicleConfigStepComponent } from "./features/vehicle-config/vehicle-config-step/vehicle-config-step.component";
import { QuoteRecapContentComponent } from "./features/vehicle-config/quote-recap-content/quote-recap-content.component";

@NgModule({
  declarations: [
    VehicleDetailCardComponent,
    VoVehicleDetailCardComponent,
    OpenAppointmentsCardComponent,
    UnroadworthyVehicleBannerComponent,
    VehicleRegistrationHeaderComponent,
    ViewMediaComponent,
    MainFooterComponent,
    LoaderComponent,
    UnroadworthyWarningComponent,
    SafetyDefectsWarningComponent,
    AuthFormComponent,
    ErrorPanelComponent,
    MainMenuComponent,
    MobileMenuComponent,
    CsatDetailsCardComponent,
    CustomSelectComponent,
    ContactDetailsCardComponent,
    UnrectifiedVehicleDetailsComponent,
    PreferredGarageCardComponent,
    DetailedVehicleInfoCardComponent,
    MainHeaderComponent,
    VehicleReallocationRequestDetailsComponent,
    OpenDefectsHeaderComponent,
    OpenDefectsWarningComponent,
    AddNewPreUseInspectionHeaderComponent,
    PUITemplatesComponent,
    PreUseInspectionListComponent,
    DamageClaimsCardComponent,
    SupportTopicsCardComponent,
    ServiceProviderComponent,
    VendorServiceListComponent,
    RectifyDefectStepperComponent,
    ReviewDefectsComponent,
    VendorListComponent,
    VehicleOrderInformationComponent,
    VoStandardVehicleInformationComponent,
    NewHeaderComponent,
    DefectDigitalSignaturepadComponent,
    AuthMainComponent,
    CompletedQuoteStepperComponent,
    MyVehicleOrderComponent,
    SuccessCardComponent,
    VehicleSpecGridComponent,
    VehicleConfigStepComponent,
    QuoteRecapContentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule,
    TranslateModule,
    FormatNumberPipe,
    FormatDatePipe,
  ],
  exports: [
    VehicleDetailCardComponent,
    VoVehicleDetailCardComponent,
    OpenAppointmentsCardComponent,
    UnroadworthyVehicleBannerComponent,
    VehicleRegistrationHeaderComponent,
    ViewMediaComponent,
    MainFooterComponent,
    LoaderComponent,
    UnroadworthyWarningComponent,
    SafetyDefectsWarningComponent,
    AuthFormComponent,
    ErrorPanelComponent,
    MainMenuComponent,
    MobileMenuComponent,
    CsatDetailsCardComponent,
    CustomSelectComponent,
    ContactDetailsCardComponent,
    UnrectifiedVehicleDetailsComponent,
    PreferredGarageCardComponent,
    DetailedVehicleInfoCardComponent,
    MainHeaderComponent,
    VehicleReallocationRequestDetailsComponent,
    OpenDefectsHeaderComponent,
    OpenDefectsWarningComponent,
    AddNewPreUseInspectionHeaderComponent,
    PUITemplatesComponent,
    PreUseInspectionListComponent,
    DamageClaimsCardComponent,
    SupportTopicsCardComponent,
    ServiceProviderComponent,
    VendorServiceListComponent,
    RectifyDefectStepperComponent,
    ReviewDefectsComponent,
    VendorListComponent,
    NewHeaderComponent,
    DefectDigitalSignaturepadComponent,
    AuthMainComponent,
    CompletedQuoteStepperComponent,
    MyVehicleOrderComponent,
    SuccessCardComponent,
    VehicleSpecGridComponent,
    VehicleConfigStepComponent,
    QuoteRecapContentComponent
  ]
})
export class ComponentsModule { }
